// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const RemoteAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.remoteAssets"
        description="Remote assets."
        defaultMessage="Remote Assets"
    />
);
RemoteAssets.displayName = "RemoteAssets";

export const SearchAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.searchAssets"
        description="Search assets."
        defaultMessage="Search assets..."
    />
);
SearchAssets.displayName = "SearchAssets";

export const EditCopying = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.editCopying"
        description="Edit copying."
        defaultMessage="Edit Copying"
    />
);
EditCopying.displayName = "EditCopying";

export const Delete = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.delete" description="Delete." defaultMessage="Delete" />
);
Delete.displayName = "Delete";

export const Cancel = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.cancel" description="Cancel." defaultMessage="Cancel" />
);
Cancel.displayName = "Cancel";

export const ConfirmDelete = (props: { checkedCount: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.confirmDelete"
        description="Confirm delete."
        defaultMessage="Confirm Delete ({checkedCount})"
        values={props}
    />
);
ConfirmDelete.displayName = "ConfirmDelete";

export const ConfirmChanges = (props: { changedCount: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.confirmChanges"
        description="Confirm changes."
        defaultMessage="Confirm Changes ({changedCount})"
        values={props}
    />
);
ConfirmChanges.displayName = "ConfirmChanges";

export const CheckedCopyingAllowed = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.checkedCopyingAllowed"
        description="Checked copying allowed."
        defaultMessage="checked = copying allowed"
    />
);
CheckedCopyingAllowed.displayName = "CheckedCopyingAllowed";

export const OrganizationStorage = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.organizationStorage"
        description="Organization storage."
        defaultMessage="Organization Storage"
    />
);
OrganizationStorage.displayName = "OrganizationStorage";

export const PerAsset = (props: { size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.perAsset"
        description="Per asset."
        defaultMessage="Per asset: {size}"
        values={props}
    />
);
PerAsset.displayName = "PerAsset";

export const PerLens = (props: { size: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.perLens"
        description="Per lens."
        defaultMessage="Per lens: {size}"
        values={props}
    />
);
PerLens.displayName = "PerLens";

export const ColumnName = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.columnName" description="Column name." defaultMessage="Name" />
);
ColumnName.displayName = "ColumnName";

export const ColumnType = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.columnType" description="Column type." defaultMessage="Type" />
);
ColumnType.displayName = "ColumnType";

export const ColumnCopying = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.columnCopying"
        description="Column copying."
        defaultMessage="Copying"
    />
);
ColumnCopying.displayName = "ColumnCopying";

export const ColumnSize = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.columnSize" description="Column size." defaultMessage="Size" />
);
ColumnSize.displayName = "ColumnSize";

export const ColumnUsedBy = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.columnUsedBy"
        description="Column used by."
        defaultMessage="Used By"
    />
);
ColumnUsedBy.displayName = "ColumnUsedBy";

export const ColumnUpdated = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.columnUpdated"
        description="Column updated."
        defaultMessage="Updated"
    />
);
ColumnUpdated.displayName = "ColumnUpdated";

export const LoadingAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.loadingAssets"
        description="Loading assets."
        defaultMessage="Loading assets..."
    />
);
LoadingAssets.displayName = "LoadingAssets";

export const NoAssetsFound = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.noAssetsFound"
        description="No assets found."
        defaultMessage="No assets found"
    />
);
NoAssetsFound.displayName = "NoAssetsFound";

export const StatusInUse = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.statusInUse"
        description="Status in use."
        defaultMessage="in use"
    />
);
StatusInUse.displayName = "StatusInUse";

export const StatusChanged = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.statusChanged"
        description="Status changed."
        defaultMessage="changed"
    />
);
StatusChanged.displayName = "StatusChanged";

export const LensUsages = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.lensUsages"
        description="Lens usages."
        defaultMessage="{count} lenses"
        values={props}
    />
);
LensUsages.displayName = "LensUsages";

export const NoAssetsInOrg = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.noAssetsInOrg"
        description="No assets in org."
        defaultMessage="No remote assets in this organization"
    />
);
NoAssetsInOrg.displayName = "NoAssetsInOrg";

export const BackToRemoteAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.backToRemoteAssets"
        description="Back to remote assets."
        defaultMessage="Back to Remote Assets"
    />
);
BackToRemoteAssets.displayName = "BackToRemoteAssets";

export const DetailName = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.detailName" description="Detail name." defaultMessage="Name" />
);
DetailName.displayName = "DetailName";

export const DetailDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailDescription"
        description="Detail description."
        defaultMessage="Description"
    />
);
DetailDescription.displayName = "DetailDescription";

export const DetailSize = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.detailSize" description="Detail size." defaultMessage="Size" />
);
DetailSize.displayName = "DetailSize";

export const DetailUsedBy = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailUsedBy"
        description="Detail used by."
        defaultMessage="Used By"
    />
);
DetailUsedBy.displayName = "DetailUsedBy";

export const DetailCreated = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailCreated"
        description="Detail created."
        defaultMessage="Created"
    />
);
DetailCreated.displayName = "DetailCreated";

export const DetailUpdated = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailUpdated"
        description="Detail updated."
        defaultMessage="Updated"
    />
);
DetailUpdated.displayName = "DetailUpdated";

export const DetailCopying = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailCopying"
        description="Detail copying."
        defaultMessage="Copying"
    />
);
DetailCopying.displayName = "DetailCopying";

export const DetailCopyingAllowed = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailCopyingAllowed"
        description="Detail copying allowed."
        defaultMessage="Allowed"
    />
);
DetailCopyingAllowed.displayName = "DetailCopyingAllowed";

export const DetailCopyingNotAllowed = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailCopyingNotAllowed"
        description="Detail copying not allowed."
        defaultMessage="Not allowed"
    />
);
DetailCopyingNotAllowed.displayName = "DetailCopyingNotAllowed";

export const DetailSave = (): ReactElement => (
    <FormattedMessage id="apps.remoteAssets.components.detailSave" description="Detail save." defaultMessage="Save" />
);
DetailSave.displayName = "DetailSave";

export const DetailDelete = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailDelete"
        description="Detail delete."
        defaultMessage="Delete"
    />
);
DetailDelete.displayName = "DetailDelete";

export const DetailCreatedBy = (props: { name: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailCreatedBy"
        description="Detail created by."
        defaultMessage="by {name}"
        values={props}
    />
);
DetailCreatedBy.displayName = "DetailCreatedBy";

export const DetailUpdatedBy = (props: { name: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailUpdatedBy"
        description="Detail updated by."
        defaultMessage="by {name}"
        values={props}
    />
);
DetailUpdatedBy.displayName = "DetailUpdatedBy";

export const DetailAssetInUse = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailAssetInUse"
        description="Detail asset in use."
        defaultMessage="Cannot delete — asset is used by {count} lenses"
        values={props}
    />
);
DetailAssetInUse.displayName = "DetailAssetInUse";

export const DetailLensUsages = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailLensUsages"
        description="Detail lens usages."
        defaultMessage="{count} lenses"
        values={props}
    />
);
DetailLensUsages.displayName = "DetailLensUsages";

export const ConfirmChangesShort = (props: { changedCount: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.confirmChangesShort"
        description="Confirm changes short."
        defaultMessage="Save ({changedCount})"
        values={props}
    />
);
ConfirmChangesShort.displayName = "ConfirmChangesShort";

export const CheckedCopyingAllowedShort = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.checkedCopyingAllowedShort"
        description="Checked copying allowed short."
        defaultMessage="✓ = allowed"
    />
);
CheckedCopyingAllowedShort.displayName = "CheckedCopyingAllowedShort";

export const DeleteConfirmTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteConfirmTitle"
        description="Delete confirm title."
        defaultMessage="Delete Assets"
    />
);
DeleteConfirmTitle.displayName = "DeleteConfirmTitle";

export const DeleteConfirmMessage = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteConfirmMessage"
        description="Delete confirm message."
        defaultMessage="Are you sure you want to delete {count} assets? This action cannot be undone."
        values={props}
    />
);
DeleteConfirmMessage.displayName = "DeleteConfirmMessage";

export const DeleteConfirmSingleMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteConfirmSingleMessage"
        description="Delete confirm single message."
        defaultMessage="Are you sure you want to delete this asset? This action cannot be undone."
    />
);
DeleteConfirmSingleMessage.displayName = "DeleteConfirmSingleMessage";

export const DeleteConfirmButton = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteConfirmButton"
        description="Delete confirm button."
        defaultMessage="Delete"
    />
);
DeleteConfirmButton.displayName = "DeleteConfirmButton";

export const DeleteConfirmCancel = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteConfirmCancel"
        description="Delete confirm cancel."
        defaultMessage="Cancel"
    />
);
DeleteConfirmCancel.displayName = "DeleteConfirmCancel";

export const DeleteInlineConfirm = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteInlineConfirm"
        description="Delete inline confirm."
        defaultMessage="Are you sure?"
    />
);
DeleteInlineConfirm.displayName = "DeleteInlineConfirm";

export const DeleteInlineYes = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteInlineYes"
        description="Delete inline yes."
        defaultMessage="Confirm"
    />
);
DeleteInlineYes.displayName = "DeleteInlineYes";

export const DeleteInlineNo = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.deleteInlineNo"
        description="Delete inline no."
        defaultMessage="Cancel"
    />
);
DeleteInlineNo.displayName = "DeleteInlineNo";

export const LoadingMoreAssets = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.loadingMoreAssets"
        description="Loading more assets."
        defaultMessage="Loading more assets..."
    />
);
LoadingMoreAssets.displayName = "LoadingMoreAssets";

export const DetailLoading = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailLoading"
        description="Detail loading."
        defaultMessage="Loading..."
    />
);
DetailLoading.displayName = "DetailLoading";

export const DetailNotFound = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.detailNotFound"
        description="Detail not found."
        defaultMessage="Asset not found"
    />
);
DetailNotFound.displayName = "DetailNotFound";

export const LensUsagesToggle = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.lensUsagesToggle"
        description="Lens usages toggle."
        defaultMessage="{count} lenses ▾"
        values={props}
    />
);
LensUsagesToggle.displayName = "LensUsagesToggle";

export const LensUsagesToggleOpen = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.lensUsagesToggleOpen"
        description="Lens usages toggle open."
        defaultMessage="{count} lenses ▴"
        values={props}
    />
);
LensUsagesToggleOpen.displayName = "LensUsagesToggleOpen";

export const AndMoreLenses = (props: { count: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.andMoreLenses"
        description="And more lenses."
        defaultMessage="and {count} more"
        values={props}
    />
);
AndMoreLenses.displayName = "AndMoreLenses";

export const ShowMoreLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.showMoreLenses"
        description="Show more lenses."
        defaultMessage="Show more"
    />
);
ShowMoreLenses.displayName = "ShowMoreLenses";

export const LoadingLensUsages = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.loadingLensUsages"
        description="Loading lens usages."
        defaultMessage="Loading..."
    />
);
LoadingLensUsages.displayName = "LoadingLensUsages";

export const LensUsagesError = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.lensUsagesError"
        description="Lens usages error."
        defaultMessage="Failed to load lens details"
    />
);
LensUsagesError.displayName = "LensUsagesError";

export const ValidationNameRequired = (): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.validationNameRequired"
        description="Validation name required."
        defaultMessage="Name is required"
    />
);
ValidationNameRequired.displayName = "ValidationNameRequired";

export const ValidationNameMinLength = (props: { min: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.validationNameMinLength"
        description="Validation name min length."
        defaultMessage="Name must be at least {min} characters"
        values={props}
    />
);
ValidationNameMinLength.displayName = "ValidationNameMinLength";

export const ValidationNameMaxLength = (props: { max: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.validationNameMaxLength"
        description="Validation name max length."
        defaultMessage="Name must be at most {max} characters"
        values={props}
    />
);
ValidationNameMaxLength.displayName = "ValidationNameMaxLength";

export const ValidationDescriptionMaxLength = (props: { max: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.remoteAssets.components.validationDescriptionMaxLength"
        description="Validation description max length."
        defaultMessage="Description must be at most {max} characters"
        values={props}
    />
);
ValidationDescriptionMaxLength.displayName = "ValidationDescriptionMaxLength";
